import { useQuery } from '@tanstack/react-query';
import { ChangeEvent, FormEvent, useEffect, useState } from 'react';

import { getFactoryList } from 'api/deviceApi';
import { DeviceSearchRequest } from 'api/DeviceRequest';
import { factoryKeys } from 'api/quires/queryKeys';

import Factory from '../../model/Factory';

type DeviceSearchBoxProps = {
  searchRequest: DeviceSearchRequest;
  isLoading: boolean;
  onSubmit: (factoryInfo: Factory | null, event?: FormEvent) => void;
  isRefetch?: boolean;
};
export default function DeviceSearchBox({
  searchRequest,
  isLoading,
  onSubmit,
  isRefetch = false,
}: DeviceSearchBoxProps) {
  const { data, refetch } = useQuery(factoryKeys.all, getFactoryList, {
    enabled: false,
  });

  const [factoryId, setFactoryId] = useState('');
  const getFactoryInfo = (id: string) =>
    data?.list.find((item) => item.id === +id) ?? null;

  useEffect(() => {
    if (!data) {
      refetch();
    } else {
      const initFactoryId =
        parseInt(searchRequest?.factoryId ?? '0', 10) > 0
          ? searchRequest.factoryId
          : !data?.list || data.list.length === 0
            ? '0'
            : data.list[0]?.id.toString();

      setFactoryId(initFactoryId);
      onSubmit(getFactoryInfo(initFactoryId));
    }
  }, [data, refetch]);

  useEffect(() => {
    if (isRefetch) {
      refetch();
    }
  }, [isRefetch, refetch]);

  const onChangeFactory = (event: ChangeEvent<HTMLSelectElement>): void => {
    const changedFactoryId = event.target.value;

    setFactoryId(changedFactoryId);
    onSubmit(getFactoryInfo(changedFactoryId), event);
  };

  return (
    <form onSubmit={(event) => onSubmit(getFactoryInfo(factoryId), event)}>
      <div className={'filter-wrap'}>
        <div className={'filter'}>
          <dl>
            <dt>{'플랜트'}</dt>
            <dd className={'mg30r'}>
              <select onChange={onChangeFactory} value={factoryId}>
                {data?.list?.map((factory) => (
                  <option key={factory.id} value={factory.id}>
                    {factory.name}
                  </option>
                ))}
              </select>
            </dd>
          </dl>
        </div>
        <button
          type={'submit'}
          className={'black_white_btn btn_search'}
          disabled={isLoading}
        >
          {'검색'}
        </button>
      </div>
    </form>
  );
}
